import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { UpdateDocumentCategoryActions } from 'store/ducks/settings/document-category';

export function* updateDocumentCategoryRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/document-category/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateDocumentCategoryActions.success(data));
    notify('success', 'Categoria de documento atualizado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(UpdateDocumentCategoryActions.failure(errorMessage));
  }
}
